import { useQuery, useMutation } from '@tanstack/react-query';
import { ProfileAPI } from '@newo/api/gateway';
import type {
    TProfile,
    TBillingStripeUrlData,
    TBillingCheckoutUrlData
} from '@newo/api/gateway';
import axios from '@/utils/api/axiosInstance';

const profileAPI = new ProfileAPI(axios);

type IQueryKeys = {
    getProfile: () => [string];
};
export const QUERY_KEYS: IQueryKeys = {
    getProfile: () => ['profile']
};

// GET Profile
export const useProfileQuery = (isEnabled?: boolean) => {
    return useQuery({
        queryKey: QUERY_KEYS.getProfile(),
        queryFn: async (): Promise<TProfile> => profileAPI.getProfile(),
        enabled: isEnabled
    });
};

// GET Billing
export const useBillingQuery = (isEnabled = true) => {
    return useQuery({
        queryKey: ['billing'],
        enabled: isEnabled,
        queryFn: async () => profileAPI.getBilling()
    });
};

// GET Billing Stripe URL
export const useBillingStripeUrlMutation = () => {
    return useMutation({
        mutationFn: async (data: TBillingStripeUrlData) =>
            profileAPI.getBillingStripeUrl(data)
    });
};

// GET Billing Checkout URL
export const useBillingCheckoutUrlMutation = () => {
    return useMutation({
        mutationFn: async (data: TBillingCheckoutUrlData) =>
            profileAPI.getBillingCheckoutUrl(data)
    });
};

// COMPLETE development stage
export const useCompleteDevelopmentStageMutation = () => {
    return useMutation({
        mutationFn: async () => profileAPI.completeDevelopmentStage()
    });
};
